export const appBarHeight = {
  xs: 60,
  md: 80,
} as const
